import { useSelector } from "react-redux";
import DataTable, { Column } from "../../components/DataTable";
import { AppDispatch, RootState } from "../../store";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  getStudents,
  getStudentsByGroup,
  setPagination,
  setSearchFilters,
} from "../../features/student/StudentSlice";
import { Student } from "../../types/studentType";
import { toast } from "sonner";
import GroupApis from "../../api/groupApis";
import useConfirmToast from "../../util/hooks/useConfirmToast";

interface Props {
  groupId?: number;
  isEdit?: boolean;
  setSelectedStudentIds: React.Dispatch<React.SetStateAction<number[]>>;
  selectedStudentIds: number[];
}

export default function AddStudentsList({
  // groupId,
  isEdit,
  setSelectedStudentIds,
  selectedStudentIds,
}: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const { confirm, modal } = useConfirmToast();

  const { students, groupStudents, isLoading, pagination, searchFilters } =
    useSelector((state: RootState) => state.student);

  const { schoolBranch } = useSelector((state: RootState) => state.access);

  const branchCode = schoolBranch?.schoolBranchCode;

  useEffect(() => {
    dispatch(
      getStudents({
        branchCode,
        page: pagination.currentPage,
        size: 1000,
        ...searchFilters,
      }),
    );
  }, [
    dispatch,
    pagination.currentPage,
    pagination.pageSize,
    searchFilters,
    branchCode,
  ]);

  const tableData: Student[] = students.map((student) => ({
    ...student,
    id: student.admissionNumber,
  }));

  // const handleAddStudent = async (admissionNumber: number) => {
  //   if (!groupId) {
  //     toast.error("Please create or select a group first.");
  //     return;
  //   }

  //   try {
  //     const response = await GroupApis.addStudentToGroup(
  //       groupId,
  //       admissionNumber,
  //     );

  //     if (response?.status === 1) {
  //       toast.success("Student added successfully");

  //       dispatch(
  //         getStudentsByGroup({
  //           branchCode,
  //           page: 0,
  //           size: 1000,
  //           groupId: groupId.toString(),
  //         }),
  //       );

  //       dispatch(
  //         getStudents({
  //           branchCode,
  //           page: pagination.currentPage,
  //           size: 1000,
  //           ...searchFilters,
  //         }),
  //       );
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const addedStudentIds = new Set(
    groupStudents.map((student) => student.admissionNumber),
  );

  const columns: Column<Student>[] = [
    {
      label: "",
      accessor: "select",
      render: (item) => {
        const isChecked = selectedStudentIds.includes(item.admissionNumber);
        return (
          <input
            type="checkbox"
            className="w-3 h-3"
            checked={isChecked}
            disabled={isEdit && addedStudentIds.has(item.admissionNumber)}
            // onChange={async (e) => {
            //   if (e.target.checked && !isAdded) {
            //     const confirmed = await confirm(
            //       `Are you sure you want to add ${item.fullName} to this group?`,
            //       { confirmText: "Yes, Add Student" },
            //     );

            //     if (confirmed) {
            //       handleAddStudent(item.admissionNumber);
            //     }
            //   }
            // }}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedStudentIds((prev) => [
                  ...prev,
                  item.admissionNumber,
                ]);
              } else {
                setSelectedStudentIds((prev) =>
                  prev.filter((id) => id !== item.admissionNumber),
                );
              }
            }}
          />
        );
      },
    },
    {
      label: "SL NO.",
      accessor: "admissionNumber",
    },
    {
      label: "Profile",
      accessor: "profile",
      render: (item) => (
        <div>
          {!item?.photoUrl ? (
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-600 text-white font-semibold">
              {item.fullName.charAt(0).toUpperCase()}
            </div>
          ) : (
            <img
              src={item?.photoUrl}
              alt=""
              className="flex items-center justify-center object-cover w-10 h-10 rounded-full"
            />
          )}
        </div>
      ),
    },
    {
      label: "Student Name",
      accessor: "studentName",
      searchable: true,
      render: (item) => (
        <div className="font-bold text-sm text-neutral-400">
          {item.fullName}
        </div>
      ),
    },
    {
      label: "Class",
      accessor: "classSection",
      render: (item) => <span>{item.classSection ?? "---"}</span>,
    },
    {
      label: "Academic Cycle",
      accessor: "academicCycle",
      render: (item) => (
        <span
          className={`px-2 py-1 text-xs font-medium rounded-[4px] bg-primary-50 text-primary-600`}
        >
          {item.academicCycle}
        </span>
      ),
    },
  ];

  return (
    <div className="bg-white px-6 py-5 rounded-lg flex flex-col gap-7 w-full">
      <h3 className="text-xl text-neutral-400 font-semibold">
        Add Students to the Group/House
      </h3>
      <div className="max-h-96 overflow-y-auto flex flex-col gap-5 custom-scrollbar">
        <DataTable
          columns={columns}
          data={tableData}
          isLoading={isLoading}
          searchFilters={searchFilters}
          onSearchChange={(accessor, value) => {
            dispatch(setSearchFilters({ [accessor]: value }));
            dispatch(
              setPagination({ currentPage: 0, pageSize: pagination.pageSize }),
            );
          }}
        />
      </div>
      {modal}
    </div>
  );
}
